import { combineReducers } from 'redux';
import { KEEP_ALIVE_FAILED } from '../actions/keep-alive';
// eslint-disable-next-line default-param-last
const keepAlive = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    keepAliveError: undefined
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case KEEP_ALIVE_FAILED:
      return {
        keepAliveError: action.error
      };
    default:
      return state;
  }
};
export default combineReducers({
  keepAlive
});